<div class="asc-top">
  <div class="asc-top-left">
    <div class="asc-title-row">
      <span class="asc-title">Horario de atención</span>
      <span class="asc-badge">Nuevo</span>
    </div>
    <span class="asc-sub"
      >Fuera de este horario, el asistente no responde con IA (el mensaje queda guardado).</span
    >
  </div>
  <div class="asc-switch-col">
    <p-inputSwitch
      [ngModel]="scheduleEnabled"
      (onChange)="onScheduleToggle($event.checked)"
      [disabled]="saving"
    ></p-inputSwitch>
    <span class="asc-switch-label" [class.asc-switch-label--off]="!scheduleEnabled">{{
      scheduleEnabled ? 'Activo' : 'Inactivo'
    }}</span>
  </div>
</div>

<div class="asc-divider"></div>

<div class="asc-body" [class.asc-body--muted]="!scheduleEnabled">
  <div class="asc-time-row">
    <div class="asc-time-col">
      <span class="asc-field-label">Desde</span>
      <p-calendar
        class="asc-time-box"
        [(ngModel)]="startTime"
        [timeOnly]="true"
        hourFormat="24"
        [showIcon]="true"
        appendTo="body"
        [disabled]="saving || !scheduleEnabled"
        (onClose)="onStartTimeClose()"
      >
        <ng-template pTemplate="inputicon"><i class="pi pi-clock"></i></ng-template>
      </p-calendar>
    </div>
    <div class="asc-time-col">
      <span class="asc-field-label">Hasta</span>
      <p-calendar
        class="asc-time-box"
        [(ngModel)]="endTime"
        [timeOnly]="true"
        hourFormat="24"
        [showIcon]="true"
        appendTo="body"
        [disabled]="saving || !scheduleEnabled"
        (onClose)="onEndTimeClose()"
      >
        <ng-template pTemplate="inputicon"><i class="pi pi-clock"></i></ng-template>
      </p-calendar>
    </div>
  </div>

  <div class="asc-tz-row">
    <i class="pi pi-globe"></i>
    <span>Zona horaria: America/Santiago</span>
  </div>

  <div class="asc-note" *ngIf="channelNote">
    <i class="pi pi-info-circle"></i>
    <span>{{ channelNote }}</span>
  </div>
</div>

<div class="asc-divider"></div>

<div class="asc-away" [class.asc-body--muted]="!scheduleEnabled">
  <div class="asc-away-top">
    <div class="asc-top-left">
      <span class="asc-title asc-title--sm">Mensaje de aviso fuera de horario</span>
      <span class="asc-sub">{{
        scheduleEnabled
          ? 'Opcional. Se envía como única respuesta cuando llega un mensaje fuera de horario.'
          : 'Activa primero el horario de atención para poder configurar este aviso.'
      }}</span>
    </div>
    <div class="asc-switch-col">
      <p-inputSwitch
        [ngModel]="awayMessageEnabled"
        (onChange)="onAwayMessageToggle($event.checked)"
        [disabled]="saving || !scheduleEnabled"
      ></p-inputSwitch>
      <span class="asc-switch-label" [class.asc-switch-label--off]="!awayMessageEnabled">{{
        awayMessageEnabled ? 'Activo' : 'Inactivo'
      }}</span>
    </div>
  </div>

  <textarea
    pInputTextarea
    class="asc-away-textarea"
    [rows]="2"
    [disabled]="saving || !scheduleEnabled || !awayMessageEnabled"
    [(ngModel)]="awayMessageText"
    (blur)="onAwayMessageBlur()"
    placeholder="Ej.: Estamos fuera de horario 🙏"
    [maxlength]="awayMessageMaxLength"
  ></textarea>
</div>
